import { deriveAppUrl } from '@/lib/appUrl';
import { isValid } from '@/lib/redirect';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from './auth';
export const useSidebarStore = defineStore('sidebar', () => {
  const route = useRoute();
  const router = useRouter();
  const selectedOption = ref(-1);
  const authStore = useAuthStore();
  const currentPath = computed(() => route.path);

  const isBilling = computed(() => currentPath.value.includes('/billing'));
  const isProfile = computed(() => currentPath.value.includes('/account/profile'));
  const isPassword = computed(() => currentPath.value.includes('/password'));
  const isRefer = computed(() => currentPath.value.includes('/refer'));

  const options = computed(() => [
    {
      goto: getAppUrl(),
      icon: 'arrow-left',
      textKey: 'sidebar_start_writing',
      selected: false,
      requiresUser: true,
    },
    {
      goto: '/account/profile',
      icon: 'profile',
      textKey: 'sidebar_user_profile',
      selected: isProfile.value,
      requiresUser: true,
    },
    {
      goto: '/account/password',
      icon: 'rename',
      textKey: 'sidebar_password',
      selected: isPassword.value,
      requiresUser: true,
    },
    {
      goto: '/billing/portal',
      icon: 'billing',
      textKey: 'sidebar_billing_nav',
      selected: isBilling.value,
      requiresUser: true,
    },
    {
      goto: '/account/referral',
      icon: 'trophy',
      textKey: 'sidebar_refer_friend',
      selected: isRefer.value,
      requiresUser: true,
    },
    {
      isSwitchAccount: true,
      icon: 'user-switch',
      textKey: 'sidebar_switch_account',
      requiresUser: true,
    },
    {
      goto: '/',
      icon: 'sign-out',
      textKey: 'sidebar_sign_out',
      requiresUser: true,
      preAction: async () => {
        await authStore.logout();
      },
    },
  ]);

  function getAppUrl() {
    const stored = sessionStorage.getItem('redirect');
    if (stored && isValid(stored)) return stored;

    const referrer = document.referrer;
    if (referrer) {
      try {
        const ref = new URL(referrer);
        if (ref.origin !== location.origin && isValid(referrer)) return referrer;
      } catch {
        return 'https://app.dabblewriter.com';
      }
    }

    return deriveAppUrl();
  }

  function selectOption(index: number) {
    selectedOption.value = index;
    const option = options.value[index];
    if (!option || !option.goto) return;
    if (/^https?:\/\//i.test(option.goto)) {
      sessionStorage.removeItem('redirect');
      window.location.href = option.goto;
      return;
    }
    router.push(option.goto);
  }

  return {
    options,
    selectOption,
  };
});
